<template>
  <div>
    <MainForm
      :name="FORM_NAMES.merchant"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Main form title"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.contact"
        ui-title="Contact Information"
        ui-subtitle=""
        ui-error-message="Please review the fields marked in red"
        ui-button-text="Submit"
      >
        <FieldsetFullName />
        <FieldsetModel :ui="uiBaseFieldset" name="companyName" ui-title="Company Name">
          <UiWrapper :name="FIELD_NAMES.companyName" label="Type the name of your company">
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetEmail subtitle="" />

        <FieldsetMobilePhone subtitle="" />

        <FieldsetModel :ui="uiBaseFieldset" name="emirates" ui-title="Emirate">
          <UiWrapper :name="FIELD_NAMES.emirates">
            <Dropdown
              placeholder="Emirate"
              :options="[
                {
                  value: 'Abu Dhabi',
                  label: 'Abu Dhabi'
                },
                {
                  value: 'Dubai',
                  label: 'Dubai'
                },
                {
                  value: 'Sharjah',
                  label: 'Sharjah'
                },
                {
                  value: 'Ajman',
                  label: 'Ajman'
                },
                {
                  value: 'Umm Al Quwain',
                  label: 'Umm Al Quwain'
                },
                {
                  value: 'Ras Al Khaimah',
                  label: 'Ras Al Khaimah'
                },
                {
                  value: 'Fujairah',
                  label: 'Fujairah'
                }
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <!-- <FieldsetModel :ui="uiBaseFieldset" name="productInterested" ui-title="Product Interested">
          <UiWrapper :name="FIELD_NAMES.productInterested">
            <Dropdown
              placeholder="Select Product"
              :options="[
                { value: 'Corporate Deposit', label: 'Corporate Deposit' },
                { value: 'High Yield', label: 'High Yield' },
                {
                  value: 'Financial Guarantees',
                  label: 'Financial Guarantees'
                },
                { value: 'Payroll Solutions', label: 'Payroll Solutions' }
              ]"
            />
          </UiWrapper>
        </FieldsetModel> -->
      </StepModel>

      <!-- <StepOtp :change-phone-action="goToStep(STEP_NAMES.contact)" /> -->
    </MainForm>
  </div>
</template>

<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import FIELD_NAMES from "@/forms/constants/field-names";
import * as conditions from "@/forms/conditions";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetModel from "@/lib/components/models/fieldset";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import StepOtp from "@/forms/components/shared/steps/otp";

import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import { Dropdown, InputText } from "@dunia/ui";
export default {
  name: "Merchant",

  components: {
    MainForm,
    StepModel,
    StepOtp,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    FIELD_NAMES,
    FieldsetModel,
    UiWrapper,
    Dropdown,
    InputText
  },

  mixins: [FormComponentMixin],
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods: {
    finishCallback() {
      var titleMessage = `Thank you for your interest.`;
      var subtitleMessage = `Our team will get in touch with you shortly.`;
      this.showEndPage({
        title: titleMessage,
        subtitle: subtitleMessage
        //actionNameEndForm: "Thanks"
      });
    }
  }
};
</script>
